import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dbca754"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "landing_page_wrapper" }
const _hoisted_3 = { class: "lp_image_wrapper p-relative d-block" }
const _hoisted_4 = { class: "item-overlay" }
const _hoisted_5 = ["data-tooltip"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "lp_title" }
const _hoisted_8 = {
  key: 0,
  class: "lp_text"
}
const _hoisted_9 = {
  key: 1,
  class: "ap-input-group"
}
const _hoisted_10 = {
  key: 0,
  class: "ap-input-label"
}
const _hoisted_11 = { class: "d-flex gap-2 mb-20" }
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = ["placeholder", "disabled", "value"]
const _hoisted_14 = {
  key: 0,
  class: "grow-width gap-2"
}
const _hoisted_15 = {
  key: 0,
  style: {"flex":"125px 0 0"}
}

import { computed, inject, ref } from 'vue';
    import { useStore } from '@/store';
    import { SelectOptionWithData } from '@/models/SelectOption';
    import { ContactFieldOptions } from '@/store/generalStore';
    import { VueFinalModalProperty } from 'vue-final-modal';
    import AddLandingPageLink from '@/components/Modals/SMSModals/AddLandingPageLink.vue';
    import SelectTemplate from '@/components/Modals/SMSModals/SelectTemplate.vue';
    import { PageModel } from '@/models/SMS';
    import { EmailSMSTemplateRowResource } from '@/models/SMS';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MessageBlock',
  props: {
        id: {
            required: true,
            type: [String, Number],
        },
        addTracking: Boolean,
        modelValue: String,
        showCreateTemlpate: {
            type: Boolean,
            default: false,
        },
        showSelectTemplate: {
            type: Boolean,
            default: true,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        showValidation: {
            type: Boolean,
            default: false,
        },
        showTracking: {
            type: Boolean,
            default: false,
        },
        isEmail: {
            type: Boolean,
            default: false,
        },
        templateId: {
            type: [String, null],
        },
        readonly: Boolean,
    },
  emits: ['update:modelValue', 'update:addTracking', 'update:templateId'],
  setup(__props, { emit }) {

const props = __props;

    const $vfm = inject('$vfm') as VueFinalModalProperty;

    const store = useStore();
    const emailTemlpates = computed(() => store.state.Newsletters);
    const ContactFields = computed(() => store.getters.AllContactFields as SelectOptionWithData<ContactFieldOptions>[]);
    const GetEmailPreview = computed(() => store.getters['GetEmailPreview']);

    const DesignedTemplate = computed(
        () => props.isEmail && props.templateId && emailTemlpates.value.find((x) => x.Id == props.templateId && !x.IsTextTemplate)
    );

    const messageInput = ref<HTMLInputElement>();

    
    

    function updateValue(value: string) {
        emit('update:modelValue', value);
        emit('update:templateId', null);
    }
    function onAddTemplate() {
        $vfm.show('select_template-' + props.id);
    }

    function onAddLink() {
        $vfm.show('add_link-' + props.id);
        emit('update:templateId', null);
    }
    function selectPageLink(pageLink: PageModel) {
        addKeyword('PageLink:' + pageLink.Name);
        $vfm.hide('add_link-' + props.id);
    }

    function selectTemplate(template: EmailSMSTemplateRowResource | null) {
        if (template == null) {
            return;
        }
        emit('update:modelValue', template.Message);
        emit('update:templateId', template.Id);
        $vfm.hide('select_template-' + props.id);
    }

    function setDesignedTemplate(template?: EmailSMSTemplateRowResource | null) {
        emit('update:templateId', template?.Id || null);
    }

    function addKeyword(keyword: string) {
        insertIntoTextArea('[' + keyword + ']');
        emit('update:templateId', null);
    }
    function insertIntoTextArea(textToInsert: string) {
        const el = messageInput.value;
        if (!el) return;
        el.focus();
        el.value += textToInsert + ' ';
        emit('update:modelValue', el.value as string);
    }

return (_ctx: any,_cache: any) => {
  const _component_ap_button = _resolveComponent("ap-button")!
  const _component_drop_button = _resolveComponent("drop-button")!
  const _component_ap_checkbox = _resolveComponent("ap-checkbox")!

  return (DesignedTemplate.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "ap-icon-delete",
                "data-tooltip": _ctx.$t('general.delete'),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setDesignedTemplate(null)), ["stop"]))
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("img", {
              class: "img-content",
              src: GetEmailPreview.value(DesignedTemplate.value.Id) || undefined
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(DesignedTemplate.value.Name), 1),
          (DesignedTemplate.value.UpdatedAt)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.lastUpdatedString(DesignedTemplate.value.UpdatedAt)), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        (__props.showTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('page.send-email.content.message.title')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("textarea", {
              class: _normalizeClass(["ap-input mb-20", { invalid: __props.showValidation && !__props.modelValue }]),
              placeholder: _ctx.$t('page.send-email.content.message.placeholder'),
              rows: "10",
              required: "",
              disabled: __props.readonly,
              value: __props.modelValue,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (updateValue($event?.target?.value))),
              ref_key: "messageInput",
              ref: messageInput
            }, null, 42, _hoisted_13),
            (!__props.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (__props.showSelectTemplate)
                    ? (_openBlock(), _createBlock(_component_ap_button, {
                        key: 0,
                        btnClass: "btn-outline-primary",
                        title: _ctx.$t('page.send-email.content.message-action.template'),
                        onClick: onAddTemplate
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ap_button, {
                    btnClass: "btn-outline-primary",
                    title: _ctx.$t('page.send-email.content.message-action.landing-page'),
                    onClick: onAddLink
                  }, null, 8, ["title"]),
                  _createVNode(_component_drop_button, {
                    btnClass: "btn-outline-primary",
                    "max-height": "200px",
                    title: _ctx.$t('page.send-email.content.message-action.contact-field.title')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ContactFields.value, (field) => {
                        return (_openBlock(), _createBlock(_component_ap_button, {
                          onClick: ($event: any) => (addKeyword(field.data.Keyword)),
                          title: field.text
                        }, null, 8, ["onClick", "title"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (!__props.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_ap_button, {
                  btnClass: "btn-outline-primary w-100 mb-16",
                  title: _ctx.$t('page.send-email.content.message-action.clear'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (updateValue('')))
                }, null, 8, ["title"]),
                (__props.showCreateTemlpate)
                  ? (_openBlock(), _createBlock(_component_ap_button, {
                      key: 0,
                      btnClass: "btn-outline-primary w-100",
                      title: _ctx.$t('page.send-email.content.message-action.save-as-template')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.showTracking && !__props.isEmail)
          ? (_openBlock(), _createBlock(_component_ap_checkbox, {
              key: 1,
              label: _ctx.$t('page.send-sms.content.add-tracking'),
              modelValue: __props.addTracking,
              disabled: __props.readonly,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = (val) => emit('update:addTracking', val)),
              theme: "outline"
            }, null, 8, ["label", "modelValue", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(AddLandingPageLink, {
          name: 'add_link-' + __props.id,
          class: "add_link",
          onSelectPage: selectPageLink
        }, null, 8, ["name"]),
        _createVNode(SelectTemplate, {
          name: 'select_template-' + __props.id,
          onTemplateSelected: selectTemplate,
          onSetDesignedTemplate: setDesignedTemplate,
          "is-email": __props.isEmail
        }, null, 8, ["name", "is-email"])
      ]))
}
}

})